module.exports = __webpack_public_path__ + "33a1fcee49e72b4de264074e5d144c2a.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/814.png
// module id = 1717
// module chunks = 2